import type { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

type MemoizedCollapseState = Record<string, any>;

type MemoizedCollapseStateReducers = {
    set: CaseReducer<MemoizedCollapseState, PayloadAction<{ key: string; value: boolean }>>;
};

const initialState = {};

export const collapseStateSlice = createSlice<MemoizedCollapseState, MemoizedCollapseStateReducers, 'collapseState'>({
    name: 'collapseState',
    initialState,
    reducers: {
        set: (state, action) => {
            state[action.payload.key] = action.payload.value;
        },
    },
});

export const { set: setCollapseState } = collapseStateSlice.actions;

export const collapseStateSelectors = {
    getCollapseStateValues: (state: MemoizedCollapseState) => state,
};
